import { requests } from '../index';
import axios from 'axios';
import URLS from "../endPoints";
let Ilearn = {}

// Auth.login = () => requests.get()
// Ilearn.getCourseById = async (payload) => await axios.post("http://localhost:3001/Career/getCourseById",payload);
//   Ilearn.getAllCourse = async () => await axios.post("http://localhost:3001/Career/getAllCourses");

Ilearn.getCourseById = async (payload) => await requests.post(URLS.magUrl.GetCourseById,payload) //api call
Ilearn.getAllCourse = async () => await requests.post(URLS.magUrl.GetAllCourse) //api call

export default Ilearn